const WebhookAuthenticationTypesLabels = Object.freeze({
  none: 'Authentication_Type_None',
  basic: 'Authentication_Type_Basic',
  bearer: 'Authentication_Type_BearerToken',
  signed: 'Authentication_Type_Signed',
  oauth2: 'Authentication_Type_OAuth2'
})

const S3AuthenticationTypesLabels = Object.freeze({
  basic: 'Integrations_S3_Type_Basic',
  assume_role: 'Integrations_S3_Type_AssumeRole'
})

const OptimoveAuthenticationTypesLabels = Object.freeze({
  0: 'Integrations_Optimove_Field_AuthType_Username',
  1: 'Integrations_Optimove_Field_Api'
})
const OptimoveAuthenticationTypes = Object.freeze({
  username: 0,
  api: 1
})

const OauthGrantTypesLabels = Object.freeze({
  client_credentials: 'OAuth_GrantType_ClientCredentials'
})

const SnowflakeAuthenticationTypesLabels = Object.freeze({
  key_pair: 'Integrations_Snowflake_AuthMethod_KeyPair',
  password: 'Integrations_Snowflake_AuthMethod_Password'
})

export {
  WebhookAuthenticationTypesLabels,
  OptimoveAuthenticationTypesLabels,
  OptimoveAuthenticationTypes,
  OauthGrantTypesLabels,
  S3AuthenticationTypesLabels,
  SnowflakeAuthenticationTypesLabels
}



// WEBPACK FOOTER //
// ./src/modules/integrations/enum/AuthenticationTypesEnum.js